(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mw-airplane-seat-bundle"] && !Shopify.designMode) return;
  try {
    const initializeAirplaneBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-airplane]:not([data-airplane-ready])').forEach((bundle) => {
      bundle.dataset.airplaneReady = 'true';
      const details = bundle.closest('.product-details') || document;
      const variants = JSON.parse(bundle.querySelector('[data-airplane-variant-map]')?.textContent || '[]');
      const activeChoice = () => bundle.querySelector('.mw-airplane-bundle__choice input[type="radio"]:checked')?.closest('.mw-airplane-bundle__choice');
      const addProperty = (form, name, value) => {
        const property = document.createElement('input');
        property.type = 'hidden';
        property.name = `properties[${name}]`;
        property.value = value;
        property.dataset.airplaneProperty = 'true';
        form.appendChild(property);
      };

      const syncSelection = () => {
        const choice = activeChoice();
        if (!choice) return;
        const picker = details.querySelector('variant-picker');
        const forms = Array.from(details.querySelectorAll('form[action*="/cart/add"]'));
        const bundleName = choice.querySelector('input[type="radio"]')?.value || 'Buy 1';
        const bundleTarget = Array.from(picker?.querySelectorAll('input[data-option-name="Bundle"]') || []).find((input) => input.value === bundleName);
        if (bundleTarget && !bundleTarget.checked) {
          bundleTarget.click();
          window.setTimeout(syncSelection, 120);
          return;
        }
        const selects = Array.from(choice.querySelectorAll('[data-airplane-design]'));
        const selectedValue = (design) => design?.dataset.value || '';
        const designTarget = Array.from(picker?.querySelectorAll('input[data-option-name="Design"]') || []).find((input) => input.value === selectedValue(selects[0]));
        if (designTarget && !designTarget.checked) {
          designTarget.click();
          window.setTimeout(syncSelection, 120);
          return;
        }
        const selectedVariant = variants.find((variant) => variant.option1 === selectedValue(selects[0]) && variant.option2 === bundleName);
        forms.forEach((form) => {
          form.querySelectorAll('[data-airplane-property]').forEach((input) => input.remove());
          const variantInput = form.querySelector('[name="id"]');
          if (variantInput && selectedVariant?.id) variantInput.value = selectedVariant.id;
          addProperty(form, 'Bundle', bundleName);
          selects.forEach((select, index) => addProperty(form, `Design ${index + 1}`, selectedValue(select)));
        });
        if (selectedVariant?.id) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', selectedVariant.id);
          window.history.replaceState({}, '', currentUrl);
        }
      };

      bundle.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) syncSelection();
      });

      bundle.addEventListener('click', (event) => {
        const trigger = event.target.closest('.mw-airplane-design-picker__trigger');
        const option = event.target.closest('[data-airplane-design-option]');
        if (trigger) {
          event.preventDefault();
          event.stopPropagation();
          const design = trigger.closest('[data-airplane-design]');
          const menu = design.querySelector('.mw-airplane-design-picker__menu');
          const opening = menu.hidden;
          bundle.querySelectorAll('.mw-airplane-design-picker__menu').forEach((item) => { item.hidden = true; });
          bundle.querySelectorAll('.mw-airplane-design-picker__trigger').forEach((item) => item.setAttribute('aria-expanded', 'false'));
          menu.hidden = !opening;
          trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
          return;
        }
        if (option) {
          event.preventDefault();
          event.stopPropagation();
          const design = option.closest('[data-airplane-design]');
          const triggerButton = design.querySelector('.mw-airplane-design-picker__trigger');
          const value = option.dataset.airplaneDesignOption;
          design.dataset.value = value;
          design.querySelector('[data-airplane-design-label]').textContent = value;
          design.querySelectorAll('[data-airplane-design-option]').forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
          const targetThumb = triggerButton.querySelector('.mw-airplane-design-picker__thumb');
          const sourceThumb = option.querySelector('.mw-airplane-design-picker__thumb');
          targetThumb.innerHTML = sourceThumb.innerHTML;
          design.querySelector('.mw-airplane-design-picker__menu').hidden = true;
          triggerButton.setAttribute('aria-expanded', 'false');
          syncSelection();
        }
      });

      const timer = bundle.querySelector('[data-airplane-countdown]');
      if (timer) {
        const storageKey = 'mw-airplane-offer-expiry';
        let expiry = Number(sessionStorage.getItem(storageKey));
        if (!expiry || expiry <= Date.now()) {
          expiry = Date.now() + 15 * 60 * 1000;
          sessionStorage.setItem(storageKey, String(expiry));
        }
        const tick = () => {
          let remaining = Math.max(0, expiry - Date.now());
          if (remaining === 0) {
            expiry = Date.now() + 15 * 60 * 1000;
            sessionStorage.setItem(storageKey, String(expiry));
            remaining = 15 * 60 * 1000;
          }
          const totalSeconds = Math.floor(remaining / 1000);
          timer.textContent = `${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, '0')}`;
        };
        tick();
        window.setInterval(tick, 1000);
      }

      syncSelection();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAirplaneBundles());
  else initializeAirplaneBundles();
  document.addEventListener('shopify:section:load', (event) => initializeAirplaneBundles(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-bundle-trust"] && !Shopify.designMode) return;
  try {
    const initializeModernWinkBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-bundle]:not([data-mw-ready])').forEach((bundle) => {
      bundle.dataset.mwReady = 'true';
      const endTime = Date.now() + 15 * 60000;
      const timer = bundle.querySelector('.mw-bundle-trust__timer');
      const ended = bundle.querySelector('[data-sale-ended]');
      const updateTimer = () => {
        const remaining = endTime - Date.now();
        if (!Number.isFinite(endTime) || remaining <= 0) {
          if (timer) timer.hidden = true;
          if (ended) ended.hidden = false;
          return false;
        }
        const values = {
          minutes: Math.floor(remaining / 60000),
          seconds: Math.floor((remaining % 60000) / 1000)
        };
        Object.entries(values).forEach(([key, value]) => {
          const target = bundle.querySelector(`[data-${key}]`);
          if (!target) return;
          target.textContent = String(value).padStart(2, '0');
        });
        return true;
      };
      updateTimer();
      bundle._mwTimer = window.setInterval(() => {
        if (!bundle.isConnected || !updateTimer()) window.clearInterval(bundle._mwTimer);
      }, 250);
      const applyQuantity = (choice) => {
        const quantityInput = bundle.closest('.product-details')?.querySelector('input[name="quantity"]');
        if (!quantityInput) return;
        quantityInput.value = choice.value;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const initialChoice = bundle.querySelector('input[type="radio"]:checked');
      if (initialChoice) applyQuantity(initialChoice);
      bundle.addEventListener('change', (event) => {
        const choice = event.target.closest('input[type="radio"]');
        if (!choice) return;
        applyQuantity(choice);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeModernWinkBundles());
  else initializeModernWinkBundles();
  document.addEventListener('shopify:section:load', (event) => initializeModernWinkBundles(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-led-helmet-bundle"] && !Shopify.designMode) return;
  try {
    const initializeHelmetBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-helmet]:not([data-helmet-ready])').forEach((bundle) => {
      bundle.dataset.helmetReady = 'true';
      const details = bundle.closest('.product-details') || document;
      const variants = JSON.parse(bundle.querySelector('[data-helmet-variant-map]')?.textContent || '[]');
      const addonConfig = JSON.parse(bundle.querySelector('[data-helmet-addon-config]')?.textContent || '{}');
      const addonStorageKey = 'mw-helmet-selected-addons';
      const addonState = (() => {
        try {
          const stored = JSON.parse(sessionStorage.getItem(addonStorageKey) || '{}');
          return { guarantee: Boolean(stored.guarantee), shipping: Boolean(stored.shipping), gift: Boolean(stored.gift) };
        } catch (error) {
          return { guarantee: false, shipping: false, gift: false };
        }
      })();
      const activeChoice = () => bundle.querySelector('.mw-helmet-bundle__choice input[type="radio"]:checked')?.closest('.mw-helmet-bundle__choice');
      const activePowerType = () => bundle.querySelector('.mw-helmet-bundle__power-types input[type="radio"]:checked')?.value || 'Battery';
      const variantId = (value) => String(value || '').split('/').pop();
      const syncAddonButtons = () => {
        bundle.querySelectorAll('[data-mw-helmet-addon]').forEach((button) => {
          button.setAttribute('aria-checked', addonState[button.dataset.mwHelmetAddon] ? 'true' : 'false');
        });
        sessionStorage.setItem(addonStorageKey, JSON.stringify(addonState));
      };
      const ensureSelectedAddons = async () => {
        const selectedIds = Object.entries(addonState)
          .filter(([, selected]) => selected)
          .map(([key]) => variantId(addonConfig[key]))
          .filter(Boolean);
        if (!selectedIds.length) return;
        const shopRoot = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${shopRoot}cart.js`);
        if (!cartResponse.ok) throw new Error('Unable to read cart');
        const cart = await cartResponse.json();
        const existingIds = new Set(cart.items.map((item) => String(item.variant_id)));
        const items = selectedIds.filter((id) => !existingIds.has(id)).map((id) => ({ id, quantity: 1 }));
        if (!items.length) return;
        const addResponse = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!addResponse.ok) throw new Error('Unable to add selected extras');
      };
      const syncPrices = () => {
        const priceKey = activePowerType() === 'Rechargeable' ? 'rechargeable' : 'battery';
        bundle.querySelectorAll('[data-helmet-price]').forEach((element) => {
          if (element.dataset[priceKey]) element.textContent = element.dataset[priceKey];
        });
      };
      const addProperty = (form, name, value) => {
        const property = document.createElement('input');
        property.type = 'hidden';
        property.name = `properties[${name}]`;
        property.value = value;
        property.dataset.helmetProperty = 'true';
        form.appendChild(property);
      };

      const syncSelection = () => {
        const choice = activeChoice();
        if (!choice) return;
        const picker = details.querySelector('variant-picker');
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
        const bundleName = choice.querySelector('input[type="radio"]')?.value || 'Buy 1';
        const powerType = activePowerType();
        const bundleTarget = Array.from(picker?.querySelectorAll('input[data-option-name="Bundle"]') || []).find((input) => input.value === bundleName);
        if (bundleTarget && !bundleTarget.checked) {
          bundleTarget.click();
          window.setTimeout(syncSelection, 120);
          return;
        }
        const powerTarget = Array.from(picker?.querySelectorAll('input[data-option-name="Power Type"]') || []).find((input) => input.value === powerType);
        if (powerTarget && !powerTarget.checked) {
          powerTarget.click();
          window.setTimeout(syncSelection, 120);
          return;
        }
        const selects = Array.from(choice.querySelectorAll('[data-helmet-design]'));
        const selectedValue = (design) => design?.dataset.value || '';
        const designTarget = Array.from(picker?.querySelectorAll('input[data-option-name="Color"]') || []).find((input) => input.value === selectedValue(selects[0]));
        if (designTarget && !designTarget.checked) {
          designTarget.click();
          window.setTimeout(syncSelection, 120);
          return;
        }
        const selectedVariant = variants.find((variant) => variant.option1 === selectedValue(selects[0]) && variant.option2 === bundleName && variant.option3 === powerType);
        forms.forEach((form) => {
          form.querySelectorAll('[data-helmet-property]').forEach((input) => input.remove());
          const variantInput = form.querySelector('[name="id"]');
          if (variantInput && selectedVariant?.id) variantInput.value = selectedVariant.id;
          addProperty(form, 'Bundle', bundleName);
          addProperty(form, 'Power Type', powerType);
          selects.forEach((select, index) => addProperty(form, `Color ${index + 1}`, selectedValue(select)));
        });
        syncPrices();
        if (selectedVariant?.id) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', selectedVariant.id);
          window.history.replaceState({}, '', currentUrl);
        }
      };

      bundle.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) {
          syncPrices();
          syncSelection();
        }
      });

      bundle.addEventListener('click', (event) => {
        const addonButton = event.target.closest('[data-mw-helmet-addon]');
        const trigger = event.target.closest('.mw-helmet-design-picker__trigger');
        const option = event.target.closest('[data-helmet-design-option]');
        if (addonButton) {
          event.preventDefault();
          event.stopPropagation();
          const key = addonButton.dataset.mwHelmetAddon;
          addonState[key] = !addonState[key];
          syncAddonButtons();
          return;
        }
        if (trigger) {
          event.preventDefault();
          event.stopPropagation();
          const design = trigger.closest('[data-helmet-design]');
          const menu = design.querySelector('.mw-helmet-design-picker__menu');
          const opening = menu.hidden;
          bundle.querySelectorAll('.mw-helmet-design-picker__menu').forEach((item) => { item.hidden = true; });
          bundle.querySelectorAll('.mw-helmet-design-picker__trigger').forEach((item) => item.setAttribute('aria-expanded', 'false'));
          menu.hidden = !opening;
          trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
          return;
        }
        if (option) {
          event.preventDefault();
          event.stopPropagation();
          const design = option.closest('[data-helmet-design]');
          const triggerButton = design.querySelector('.mw-helmet-design-picker__trigger');
          const value = option.dataset.helmetDesignOption;
          design.dataset.value = value;
          design.querySelector('[data-helmet-design-label]').textContent = value;
          design.querySelectorAll('[data-helmet-design-option]').forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
          const targetThumb = triggerButton.querySelector('.mw-helmet-design-picker__thumb');
          const sourceThumb = option.querySelector('.mw-helmet-design-picker__thumb');
          targetThumb.innerHTML = sourceThumb.innerHTML;
          design.querySelector('.mw-helmet-design-picker__menu').hidden = true;
          triggerButton.setAttribute('aria-expanded', 'false');
          syncSelection();
        }
      });

      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        if (form.dataset.helmetAddonsReady === 'true') return;
        form.dataset.helmetAddonsReady = 'true';
        form.addEventListener('submit', () => {
          window.mwHelmetAddonsReady = ensureSelectedAddons().catch(() => undefined);
        });
      });

      const timer = bundle.querySelector('[data-helmet-countdown]');
      if (timer) {
        const storageKey = 'mw-helmet-offer-expiry';
        let expiry = Number(sessionStorage.getItem(storageKey));
        if (!expiry || expiry <= Date.now()) {
          expiry = Date.now() + 15 * 60 * 1000;
          sessionStorage.setItem(storageKey, String(expiry));
        }
        const tick = () => {
          let remaining = Math.max(0, expiry - Date.now());
          if (remaining === 0) {
            expiry = Date.now() + 15 * 60 * 1000;
            sessionStorage.setItem(storageKey, String(expiry));
            remaining = 15 * 60 * 1000;
          }
          const totalSeconds = Math.floor(remaining / 1000);
          timer.textContent = `${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, '0')}`;
        };
        tick();
        window.setInterval(tick, 1000);
      }

      syncPrices();
      syncAddonButtons();
      syncSelection();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeHelmetBundles());
  else initializeHelmetBundles();
  document.addEventListener('shopify:section:load', (event) => initializeHelmetBundles(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-pivotx-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mwPivotxOfferBooted) return;
    window.mwPivotxOfferBooted = true;
    const states = new WeakMap();
    const bundleCopy = {
      '1.0 PTZ System': ['Starter', 'Buy 1', '1× NOXERA PRO 1.0', ''],
      'Dual Sync 1.0 PTZ System': ['Bundle deal', 'Buy 2', 'Synchronized control', 'Most popular'],
      'Dual 1.0 PTZ System': ['Bundle deal', 'Buy 2', 'Independent control', ''],
      '1.0 PTZ + 180W Spotlight Kit': ['Complete kit', 'Buy 1 + Light', 'Includes 180W spotlight', ''],
      'Dual Sync 1.0 PTZ System + Dual 180W Spotlight Kit': ['Complete bundle', 'Buy 2 + Lights', 'Synchronized control', 'Best value'],
      'Dual 1.0 PTZ + Dual 180W Spotlight Kit': ['Complete bundle', 'Buy 2 + Lights', 'Independent control', '']
    };
    const initializePivotxOffer = (root) => {
      const existing = states.get(root);
      if (existing) {
        existing.refresh();
        return;
      }
      const variants = JSON.parse(root.querySelector('[data-mw-pivotx-variants]')?.textContent || '[]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
      const storageKey = 'mw-helmet-selected-addons';
      const detail = root.closest('.product-details') || root.closest('section') || document;
      const price = root.querySelector('[data-mw-pivotx-price]');
      const compare = root.querySelector('[data-mw-pivotx-compare]');
      const save = root.querySelector('[data-mw-pivotx-save]');
      const addons = root.querySelector('.mw-pivotx-offer__addons');
      const selected = {};
      try { Object.assign(selected, JSON.parse(sessionStorage.getItem(storageKey) || '{}')); } catch (error) {}
      root.querySelectorAll('[data-mw-pivotx-addon]').forEach((button) => {
        const key = button.dataset.mwPivotxAddon;
        button.setAttribute('aria-checked', selected[key] ? 'true' : 'false');
        button.addEventListener('click', () => {
          const checked = button.getAttribute('aria-checked') !== 'true';
          button.setAttribute('aria-checked', String(checked));
          selected[key] = checked;
          sessionStorage.setItem(storageKey, JSON.stringify(selected));
        });
      });
      const decorateBundlePicker = () => {
        const bundlePicker = Array.from(detail.querySelectorAll('variant-picker fieldset')).find((fieldset) => fieldset.classList.contains('mw-bundle-picker') || fieldset.querySelector('legend')?.textContent.trim() === 'Choose Your Setup');
        if (!bundlePicker) return;
        bundlePicker.classList.add('mw-bundle-picker');
        bundlePicker.querySelectorAll('label').forEach((label) => {
          if (label.dataset.mwBundleReady === 'true') return;
          const input = label.querySelector('input[type="radio"]');
          const text = label.querySelector('[data-key="variant-option-text"]');
          const copy = bundleCopy[input?.value];
          if (!input || !text || !copy) return;
          label.dataset.mwBundleReady = 'true';
          text.textContent = copy[1];
          text.classList.add('mw-bundle-title');
          const eyebrow = document.createElement('span');
          eyebrow.className = 'mw-bundle-eyebrow';
          eyebrow.textContent = copy[0];
          text.before(eyebrow);
          const subtitle = document.createElement('span');
          subtitle.className = 'mw-bundle-subtitle';
          subtitle.textContent = copy[2];
          text.after(subtitle);
          if (copy[3]) {
            const badge = document.createElement('span');
            badge.className = 'mw-bundle-badge';
            badge.textContent = copy[3];
            label.append(badge);
          }
        });
      };
      const placeAddons = () => {
        const buyButtons = detail.querySelector('.buy-buttons-block');
        if (addons && buyButtons && addons.nextElementSibling !== buyButtons) buyButtons.before(addons);
      };
      const selectedVariant = () => {
        const selectedValues = Array.from(detail.querySelectorAll('variant-picker input[type="radio"]:checked')).map((input) => input.value);
        return variants.find((item) => Array.isArray(item.options) && item.options.every((option) => selectedValues.includes(option)));
      };
      const syncProductFormVariant = () => {
        const variant = selectedVariant();
        if (!variant) return;
        detail.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
          input.value = String(variant.id);
        });
      };
      const switchProductMedia = () => {
        const values = Array.from(detail.querySelectorAll('variant-picker input[type="radio"]:checked')).map((input) => input.value);
        const mount = values.includes('Quick-Mount') ? 'Quick-Mount' : 'Magnetic';
        const setup = values.find((value) => value !== 'Magnetic' && value !== 'Quick-Mount');
        const positions = {
          Magnetic: {
            '1.0 PTZ System': 9,
            'Dual Sync 1.0 PTZ System': 11,
            'Dual 1.0 PTZ System': 10,
            '1.0 PTZ + 180W Spotlight Kit': 12,
            'Dual Sync 1.0 PTZ System + Dual 180W Spotlight Kit': 14,
            'Dual 1.0 PTZ + Dual 180W Spotlight Kit': 13
          },
          'Quick-Mount': {
            '1.0 PTZ System': 17,
            'Dual Sync 1.0 PTZ System': 19,
            'Dual 1.0 PTZ System': 18,
            '1.0 PTZ + 180W Spotlight Kit': 20,
            'Dual Sync 1.0 PTZ System + Dual 180W Spotlight Kit': 22,
            'Dual 1.0 PTZ + Dual 180W Spotlight Kit': 21
          }
        };
        const position = positions[mount]?.[setup];
        if (!position) return;
        const gallery = document.querySelector('media-gallery');
        const trigger = Array.from(gallery?.querySelectorAll('button[aria-label]') || []).find((button) => button.getAttribute('aria-label')?.startsWith(`Slide ${position} of`));
        trigger?.click();
      };
      const updatePrice = () => {
        const idInput = detail.querySelector('form[action*="/cart/add"] [name="id"]');
        const variant = selectedVariant() || variants.find((item) => String(item.id) === String(idInput?.value)) || variants.find((item) => item.available) || variants[0];
        if (!variant) return;
        const formattedPrice = money.format(Number(variant.price) / 100);
        if (price.textContent.trim() !== formattedPrice) price.textContent = formattedPrice;
        const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !hasCompare;
        save.hidden = !hasCompare;
        if (hasCompare) {
          const formattedCompare = money.format(Number(variant.compare_at_price) / 100);
          if (compare.textContent.trim() !== formattedCompare) compare.textContent = formattedCompare;
          const savingPercent = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
          const savingText = `Save ${savingPercent}%`;
          if (save.textContent.trim() !== savingText) save.textContent = savingText;
        }
      };
      const refresh = () => {
        decorateBundlePicker();
        placeAddons();
        syncProductFormVariant();
        updatePrice();
      };
      states.set(root, { refresh });
      refresh();
      const schedulePriceUpdate = () => {
        requestAnimationFrame(refresh);
        setTimeout(refresh, 80);
        setTimeout(refresh, 240);
        setTimeout(refresh, 650);
      };
      const scheduleMediaSwitch = () => {
        requestAnimationFrame(switchProductMedia);
        setTimeout(switchProductMedia, 260);
        setTimeout(switchProductMedia, 760);
        setTimeout(switchProductMedia, 1800);
      };
      detail.addEventListener('change', (event) => {
        schedulePriceUpdate();
        if (event.target.matches('variant-picker input[type="radio"]')) scheduleMediaSwitch();
      }, true);
      detail.addEventListener('click', (event) => {
        if (event.target.closest('.buy-buttons-block')) syncProductFormVariant();
        schedulePriceUpdate();
      }, true);
      document.addEventListener('variant-change', () => {
        schedulePriceUpdate();
        scheduleMediaSwitch();
      });
    };
    let refreshQueued = false;
    const refreshAll = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        document.querySelectorAll('[data-mw-pivotx-offer]').forEach(initializePivotxOffer);
      });
    };
    refreshAll();
    new MutationObserver(refreshAll).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', refreshAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-snuggle-bundle"] && !Shopify.designMode) return;
  try {
    const initializeSnuggleBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-snuggle]:not([data-snuggle-ready])').forEach((bundle) => {
      bundle.dataset.snuggleReady = 'true';
      const syncColorProperties = (choice) => {
        const details = bundle.closest('.product-details') || document;
        const form = details.querySelector('form[action*="/cart/add"]');
        if (!form || !choice) return;
        form.querySelectorAll('[data-snuggle-property]').forEach((input) => input.remove());
        choice.querySelectorAll('.mw-snuggle-bundle__colors select').forEach((select, index) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[Color ${index + 1}]`;
          input.value = select.value;
          input.dataset.snuggleProperty = 'true';
          form.appendChild(input);
        });
        const bundleProperty = document.createElement('input');
        bundleProperty.type = 'hidden';
        bundleProperty.name = 'properties[Bundle]';
        bundleProperty.value = choice.querySelector('input[type="radio"]')?.value || 'Buy 1';
        bundleProperty.dataset.snuggleProperty = 'true';
        form.appendChild(bundleProperty);
      };
      const selectBundleVariant = (bundleName, choice) => {
        const details = bundle.closest('.product-details') || document;
        const picker = details.querySelector('variant-picker');
        const inputs = picker?.querySelectorAll('input[data-option-name="Bundle"]');
        const target = Array.from(inputs || []).find((input) => input.value === bundleName);
        if (target && !target.checked) target.click();
        const firstColor = choice?.querySelector('.mw-snuggle-bundle__colors select')?.value;
        const colorInputs = picker?.querySelectorAll('input[data-option-name="Color"]');
        const colorTarget = Array.from(colorInputs || []).find((input) => input.value === firstColor);
        if (colorTarget && !colorTarget.checked) colorTarget.click();
        syncColorProperties(choice);
        const displayed = bundle.querySelector('[data-selected-price]');
        const prices = { 'Buy 1': '$69.99', 'Buy 2': '$119.99', 'Buy 3': '$179.99' };
        if (displayed) displayed.textContent = prices[bundleName] || prices['Buy 1'];
      };
      bundle.addEventListener('change', (event) => {
        const radio = event.target.closest('input[type="radio"]');
        if (radio) selectBundleVariant(radio.value, radio.closest('.mw-snuggle-bundle__choice'));
        const colorSelect = event.target.closest('.mw-snuggle-bundle__colors select');
        if (colorSelect) {
          const choice = colorSelect.closest('.mw-snuggle-bundle__choice');
          const radioForChoice = choice?.querySelector('input[type="radio"]');
          if (radioForChoice && !radioForChoice.checked) radioForChoice.click();
          selectBundleVariant(radioForChoice?.value || 'Buy 1', choice);
        }
      });
      bundle.querySelectorAll('.mw-snuggle-bundle__colors select').forEach((select) => {
        select.addEventListener('click', (event) => event.stopPropagation());
      });
      const initialRadio = bundle.querySelector('input[type="radio"]:checked');
      selectBundleVariant(initialRadio?.value || 'Buy 1', initialRadio?.closest('.mw-snuggle-bundle__choice'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSnuggleBundles());
  else initializeSnuggleBundles();
  document.addEventListener('shopify:section:load', (event) => initializeSnuggleBundles(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-stake-bundle"] && !Shopify.designMode) return;
  try {
    const initializeModernWinkBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-bundle]:not([data-mw-ready])').forEach((bundle) => {
      bundle.dataset.mwReady = 'true';
      const endTime = Date.now() + 15 * 60000;
      const timer = bundle.querySelector('.mw-bundle-trust__timer');
      const ended = bundle.querySelector('[data-sale-ended]');
      const updateTimer = () => {
        const remaining = endTime - Date.now();
        if (!Number.isFinite(endTime) || remaining <= 0) {
          if (timer) timer.hidden = true;
          if (ended) ended.hidden = false;
          return false;
        }
        const values = {
          minutes: Math.floor(remaining / 60000),
          seconds: Math.floor((remaining % 60000) / 1000)
        };
        Object.entries(values).forEach(([key, value]) => {
          const target = bundle.querySelector(`[data-${key}]`);
          if (!target) return;
          target.textContent = String(value).padStart(2, '0');
        });
        return true;
      };
      updateTimer();
      bundle._mwTimer = window.setInterval(() => {
        if (!bundle.isConnected || !updateTimer()) window.clearInterval(bundle._mwTimer);
      }, 250);
      const applyQuantity = (choice) => {
        const quantityInput = bundle.closest('.product-details')?.querySelector('input[name="quantity"]');
        if (!quantityInput) return;
        quantityInput.value = choice.value;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const initialChoice = bundle.querySelector('input[type="radio"]:checked');
      if (initialChoice) applyQuantity(initialChoice);
      bundle.addEventListener('change', (event) => {
        const choice = event.target.closest('input[type="radio"]');
        if (!choice) return;
        applyQuantity(choice);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeModernWinkBundles());
  else initializeModernWinkBundles();
  document.addEventListener('shopify:section:load', (event) => initializeModernWinkBundles(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mw-supercar-shower-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mwPivotxOfferBooted) return;
    window.mwPivotxOfferBooted = true;
    const states = new WeakMap();
    const bundleCopy = {
      'Single Shower System': ['', 'Buy 1', 'Standard price', ''],
      '2-System Bundle': ['', 'Buy 2', 'You save 10%', 'Most popular']
    };
    const initializePivotxOffer = (root) => {
      const existing = states.get(root);
      if (existing) {
        existing.refresh();
        return;
      }
      const variants = JSON.parse(root.querySelector('[data-mw-pivotx-variants]')?.textContent || '[]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
      const storageKey = 'mw-helmet-selected-addons';
      const detail = root.closest('.product-details') || root.closest('section') || document;
      const price = root.querySelector('[data-mw-pivotx-price]');
      const compare = root.querySelector('[data-mw-pivotx-compare]');
      const save = root.querySelector('[data-mw-pivotx-save]');
      const addons = root.querySelector('.mw-pivotx-offer__addons');
      const selected = {};
      try { Object.assign(selected, JSON.parse(sessionStorage.getItem(storageKey) || '{}')); } catch (error) {}
      root.querySelectorAll('[data-mw-pivotx-addon]').forEach((button) => {
        const key = button.dataset.mwPivotxAddon;
        button.setAttribute('aria-checked', selected[key] ? 'true' : 'false');
        button.addEventListener('click', () => {
          const checked = button.getAttribute('aria-checked') !== 'true';
          button.setAttribute('aria-checked', String(checked));
          selected[key] = checked;
          sessionStorage.setItem(storageKey, JSON.stringify(selected));
        });
      });
      const decorateBundlePicker = () => {
        const bundlePicker = Array.from(detail.querySelectorAll('variant-picker fieldset')).find((fieldset) => fieldset.classList.contains('mw-bundle-picker') || fieldset.querySelector('legend')?.textContent.trim() === 'Bundle');
        if (!bundlePicker) return;
        bundlePicker.classList.add('mw-bundle-picker');
        bundlePicker.querySelectorAll('label').forEach((label) => {
          if (label.dataset.mwBundleReady === 'true') return;
          const input = label.querySelector('input[type="radio"]');
          const text = label.querySelector('[data-key="variant-option-text"]');
          const copy = bundleCopy[input?.value];
          if (!input || !text || !copy) return;
          const optionVariant = variants.find((item) => Array.isArray(item.options) && item.options.includes(input.value));
          label.dataset.mwBundleReady = 'true';
          if (copy[3]) label.classList.add('is-popular');
          text.textContent = copy[1];
          text.classList.add('mw-bundle-title');
          const eyebrow = document.createElement('span');
          eyebrow.className = 'mw-bundle-eyebrow';
          eyebrow.textContent = copy[0];
          text.before(eyebrow);
          const subtitle = document.createElement('span');
          subtitle.className = 'mw-bundle-subtitle';
          subtitle.textContent = copy[2];
          text.after(subtitle);
          if (optionVariant) {
            const priceGroup = document.createElement('span');
            priceGroup.className = 'mw-bundle-card-price';
            const currentPrice = document.createElement('strong');
            currentPrice.textContent = money.format(Number(optionVariant.price) / 100);
            priceGroup.append(currentPrice);
            if (Number(optionVariant.compare_at_price) > Number(optionVariant.price)) {
              const oldPrice = document.createElement('del');
              oldPrice.textContent = money.format(Number(optionVariant.compare_at_price) / 100);
              priceGroup.append(oldPrice);
            }
            label.append(priceGroup);
          }
          if (copy[3]) {
            const badge = document.createElement('span');
            badge.className = 'mw-bundle-badge';
            badge.textContent = copy[3];
            label.append(badge);
          }
        });
      };
      const placeAddons = () => {
        const buyButtons = detail.querySelector('.buy-buttons-block');
        if (addons && buyButtons && addons.nextElementSibling !== buyButtons) buyButtons.before(addons);
      };
      const selectedVariant = () => {
        const selectedValues = Array.from(detail.querySelectorAll('variant-picker input[type="radio"]:checked')).map((input) => input.value);
        return variants.find((item) => Array.isArray(item.options) && item.options.every((option) => selectedValues.includes(option)));
      };
      const syncProductFormVariant = () => {
        const variant = selectedVariant();
        if (!variant) return;
        detail.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((input) => {
          input.value = String(variant.id);
        });
      };
      const switchProductMedia = () => {
        const values = Array.from(detail.querySelectorAll('variant-picker input[type="radio"]:checked')).map((input) => input.value);
        const mount = values.includes('Quick-Mount') ? 'Quick-Mount' : 'Magnetic';
        const setup = values.find((value) => value !== 'Magnetic' && value !== 'Quick-Mount');
        const positions = {
          Magnetic: {
            '1.0 PTZ System': 9,
            'Dual Sync 1.0 PTZ System': 11,
            'Dual 1.0 PTZ System': 10,
            '1.0 PTZ + 180W Spotlight Kit': 12,
            'Dual Sync 1.0 PTZ System + Dual 180W Spotlight Kit': 14,
            'Dual 1.0 PTZ + Dual 180W Spotlight Kit': 13
          },
          'Quick-Mount': {
            '1.0 PTZ System': 17,
            'Dual Sync 1.0 PTZ System': 19,
            'Dual 1.0 PTZ System': 18,
            '1.0 PTZ + 180W Spotlight Kit': 20,
            'Dual Sync 1.0 PTZ System + Dual 180W Spotlight Kit': 22,
            'Dual 1.0 PTZ + Dual 180W Spotlight Kit': 21
          }
        };
        const position = positions[mount]?.[setup];
        if (!position) return;
        const gallery = document.querySelector('media-gallery');
        const trigger = Array.from(gallery?.querySelectorAll('button[aria-label]') || []).find((button) => button.getAttribute('aria-label')?.startsWith(`Slide ${position} of`));
        trigger?.click();
      };
      const updatePrice = () => {
        const idInput = detail.querySelector('form[action*="/cart/add"] [name="id"]');
        const variant = selectedVariant() || variants.find((item) => String(item.id) === String(idInput?.value)) || variants.find((item) => item.available) || variants[0];
        if (!variant) return;
        const formattedPrice = money.format(Number(variant.price) / 100);
        if (price.textContent.trim() !== formattedPrice) price.textContent = formattedPrice;
        const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !hasCompare;
        save.hidden = !hasCompare;
        if (hasCompare) {
          const formattedCompare = money.format(Number(variant.compare_at_price) / 100);
          if (compare.textContent.trim() !== formattedCompare) compare.textContent = formattedCompare;
          const savingPercent = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
          const savingText = `Save ${savingPercent}%`;
          if (save.textContent.trim() !== savingText) save.textContent = savingText;
        }
      };
      const refresh = () => {
        decorateBundlePicker();
        placeAddons();
        syncProductFormVariant();
        updatePrice();
      };
      states.set(root, { refresh });
      refresh();
      const schedulePriceUpdate = () => {
        requestAnimationFrame(refresh);
        setTimeout(refresh, 80);
        setTimeout(refresh, 240);
        setTimeout(refresh, 650);
      };
      const scheduleMediaSwitch = () => {
        requestAnimationFrame(switchProductMedia);
        setTimeout(switchProductMedia, 260);
        setTimeout(switchProductMedia, 760);
        setTimeout(switchProductMedia, 1800);
      };
      detail.addEventListener('change', (event) => {
        schedulePriceUpdate();
        if (event.target.matches('variant-picker input[type="radio"]')) scheduleMediaSwitch();
      }, true);
      detail.addEventListener('click', (event) => {
        if (event.target.closest('.buy-buttons-block')) syncProductFormVariant();
        schedulePriceUpdate();
      }, true);
      document.addEventListener('variant-change', () => {
        schedulePriceUpdate();
        scheduleMediaSwitch();
      });
    };
    let refreshQueued = false;
    const refreshAll = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => {
        refreshQueued = false;
        document.querySelectorAll('[data-mw-pivotx-offer]').forEach(initializePivotxOffer);
      });
    };
    refreshAll();
    new MutationObserver(refreshAll).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', refreshAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
